const TOKEN_KEY = 'token'
const EXPIRES_AT_KEY = 'expire'
const USER_INFO_KEY = 'user_info'

const decodeBase64UrlJson = (value) => {
	const normalized = value.replace(/-/g, '+').replace(/_/g, '/')
	const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')
	const binary = atob(padded)
	const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0))
	return JSON.parse(new TextDecoder().decode(bytes))
}

const getJwtExpiresAt = (token) => {
	try {
		const [, payload] = token.split('.')
		if (!payload) return null
		const decodedPayload = decodeBase64UrlJson(payload)
		return Number.isFinite(decodedPayload?.exp)
			? new Date(decodedPayload.exp * 1000).toISOString()
			: null
	} catch (_error) {
		return null
	}
}

const parseCallbackToken = (value) => {
	if (!value || typeof value !== 'string') {
		throw new Error('ไม่พบ token จาก SSO')
	}

	try {
		const decoded = decodeBase64UrlJson(value)
		if (decoded && typeof decoded.token === 'string' && decoded.token) {
			return {
				token: decoded.token,
				expiresAt: decoded.expire_at || decoded.expire || null,
			}
		}
	} catch (_error) {
		// The current API contract sends a JWT directly. Base64 JSON is retained
		// as a backwards-compatible fallback for older SSO deployments.
	}

	return {
		token: value,
		expiresAt: getJwtExpiresAt(value),
	}
}

const getToken = () => localStorage.getItem(TOKEN_KEY)
const getExpiresAt = () => localStorage.getItem(EXPIRES_AT_KEY)

const getAuthSession = () => ({
	token: getToken(),
	expiresAt: getExpiresAt(),
})

const setAuthSession = ({ token, expiresAt = null }) => {
	if (!token || typeof token !== 'string') {
		throw new Error('ไม่พบ token จาก SSO')
	}

	localStorage.setItem(TOKEN_KEY, token)
	const resolvedExpiresAt = expiresAt || getJwtExpiresAt(token)
	if (resolvedExpiresAt) {
		localStorage.setItem(EXPIRES_AT_KEY, resolvedExpiresAt)
	} else {
		localStorage.removeItem(EXPIRES_AT_KEY)
	}
}

const clearAuthSession = () => {
	localStorage.removeItem(TOKEN_KEY)
	localStorage.removeItem(EXPIRES_AT_KEY)
	localStorage.removeItem(USER_INFO_KEY)
}

const isAuthSessionExpired = () => {
	const token = getToken()
	if (!token) return true

	const expiresAt = getExpiresAt()
	if (!expiresAt) return false

	const expiresAtTime = new Date(expiresAt).getTime()
	return Number.isFinite(expiresAtTime) && expiresAtTime <= Date.now()
}

const getUserInfo = () => {
	try {
		return JSON.parse(localStorage.getItem(USER_INFO_KEY)) || {}
	} catch (_error) {
		return {}
	}
}

export {
	clearAuthSession,
	getAuthSession,
	getExpiresAt,
	getToken,
	getUserInfo,
	isAuthSessionExpired,
	parseCallbackToken,
	setAuthSession,
}
